<button class="back-button" (click)="cancelAndGoBack()">
    ← Back to Pricing
</button>

<!-- Stripe Checkout Widget -->
<div *ngIf="isLoading">
    <app-loading-page [message]="'Loading Subscription Page'"></app-loading-page>
</div>
<div *ngIf="!isLoading">
    <div id="checkout">
        <!-- Checkout will insert the payment form here -->
    </div>
</div>
